import { useMutation } from 'data-fetching-client';
import { useMemo, useCallback } from 'react';
import { GET_FORM_PERMISSIONS, GET_FORM_PERMISSIONS_FIELD_NAME } from 'ui-forms-components/api/dataFetchingClient/queries/getFormPermissions';
import { SET_FORM_PERMISSIONS } from 'ui-forms-components/api/dataFetchingClient/mutations/setFormPermissions';
import { DELETE_FORM_PERMISSIONS } from 'ui-forms-components/api/dataFetchingClient/mutations/deleteFormPermissions';
const useSetFormPermissions = (formGuids, onComplete = () => {}) => {
  const [setFormPermissions, {
    loading: setFormPermissionsLoading,
    error: setFormPermissionsError
  }] = useMutation(SET_FORM_PERMISSIONS, {
    update(cache, _, {
      variables
    }) {
      if (variables) {
        const {
          selectedUserIds,
          selectedTeamIds
        } = variables.permissions;
        const {
          formGuids: formGuidsFromRequest
        } = variables;
        formGuidsFromRequest.forEach(formGuid => cache.writeQuery({
          query: GET_FORM_PERMISSIONS,
          data: {
            [GET_FORM_PERMISSIONS_FIELD_NAME]: {
              userIds: selectedUserIds,
              teamIds: selectedTeamIds
            }
          },
          variables: {
            formGuid
          }
        }));
      }
    },
    onCompleted: () => {
      onComplete();
    }
  });
  const [deleteFormPermissions, {
    loading: deleteFormPermissionsLoading,
    error: deleteFormPermissionsError
  }] = useMutation(DELETE_FORM_PERMISSIONS, {
    update(cache, _, {
      variables
    }) {
      if (variables) {
        const {
          formGuids: formGuidsFromRequest
        } = variables;
        formGuidsFromRequest.forEach(formGuid => cache.writeQuery({
          query: GET_FORM_PERMISSIONS,
          data: {
            [GET_FORM_PERMISSIONS_FIELD_NAME]: {
              userIds: [],
              teamIds: []
            }
          },
          variables: {
            formGuid
          }
        }));
      }
    },
    onCompleted: () => {
      onComplete();
    }
  });
  const handleSetFormPermissions = useCallback(updatedPermissions => {
    const {
      selectedTeamIds,
      selectedUserIds
    } = updatedPermissions;
    const submitFormGuids = Array.isArray(formGuids) ? formGuids : [formGuids];
    const isDelete = selectedTeamIds.length === 0 && selectedUserIds.length === 0;
    if (isDelete) {
      return deleteFormPermissions({
        variables: {
          formGuids: submitFormGuids
        }
      });
    } else {
      return setFormPermissions({
        variables: {
          formGuids: submitFormGuids,
          permissions: updatedPermissions
        }
      });
    }
  }, [formGuids, deleteFormPermissions, setFormPermissions]);
  const loading = useMemo(() => setFormPermissionsLoading || deleteFormPermissionsLoading, [deleteFormPermissionsLoading, setFormPermissionsLoading]);
  const error = useMemo(() => setFormPermissionsError || deleteFormPermissionsError, [setFormPermissionsError, deleteFormPermissionsError]);
  return useMemo(() => ({
    handleSetFormPermissions,
    loading,
    error
  }), [handleSetFormPermissions, loading, error]);
};
export default useSetFormPermissions;